/**
 * @typedef UpdateMarkPrice 현재가 업데이트
 * @property {string} symbol 코인 명
 * @property {string} p 현재가 (mark price)
 */
const markPriceStore = {
  namespaced: true,
  state: {
    BTCUSDT: 0,
    ETHUSDT: 0,
    XRPUSDT: 0,
    SOLUSDT: 0,
    ADAUSDT: 0,
    DOGEUSDT: 0,
    BNBUSDT: 0,
  },
  getters: {
    BTC: (state) => state.BTCUSDT.toFixed(5),
    ETH: (state) => state.ETHUSDT.toFixed(5),
    XRP: (state) => state.XRPUSDT.toFixed(5),
    SOL: (state) => state.SOLUSDT.toFixed(5),
    ADA: (state) => state.ADAUSDT.toFixed(5),
    DOGE: (state) => state.DOGEUSDT.toFixed(5),
    BNB: (state) => state.BNBUSDT.toFixed(5),
  },
  mutations: {
    /**
     * 현재가 업데이트
     * @param {Object} state
     * @param {UpdateMarkPrice} payload 업데이트할 데이터
     */
    MU_UPDATE_MARK_PRICE: (state, payload) => {
      state[payload.symbol] = Number(payload.p);
    },
  },
};

export default markPriceStore;
